import React from 'react';
import { useState } from 'react';
import SalutationModal from './SalutationModal';

const SalutationInfoButton = () => {
  const [showSalutationModal, setShowSalutationModal] = useState(false);
  const hideSalutationModal = () => {
    setShowSalutationModal(false);
  };
  return (
    <>
      <SalutationModal hideSalutationModal={hideSalutationModal} showSalutationModal={showSalutationModal} />
      <h3
        className='update-custom-contact-salutation'
        onClick={() => {
          setShowSalutationModal(true);
        }}
      >
        Salutation
        <span className='icon-info pointer ml-1 light-40-text paragraph-p3'></span>
      </h3>
    </>
  );
};

export default SalutationInfoButton;
